@if (footerVisibility()) {
    <footer class="fixedFooter tw-z-10 tw-fixed tw-bottom-0 tw-left-0">
        <div class="footer">
            <div class="navigation">
                <div class="navitems">
                    @for (footerLink of footerLinks; track footerLink.link) {
                        <div class="navitem">
                            <a
                                [href]="footerLink.link"
                                target="_blank"
                                >{{ footerLink.translationKey | translate }}</a
                            >
                        </div>
                    }
                    <div class="navitem">
                        <a routerLink="/licenses">{{
                            'GENERAL.LICENSES' | translate
                        }}</a>
                    </div>
                </div>
            </div>
            <div
                class="copyright"
                [matTooltip]="versionString()"
                matTooltipClass="tw-whitespace-pre-line tw-max-w-[320px]">
                <div class="navitem">powered by T-Systems</div>
            </div>
        </div>
    </footer>
}
